<template>
    <section class="left-right-sec">
        <loading v-model:active="isLoading"
                 :loader="'bars'"
                 :height="80"
                 :width="80"
                 :background-color="'#fff'"
                 :opacity="0.8"
                 :blur="'2px'"
                 :color="'#ff51b8'"
                 :lock-scroll="true"
                 :can-cancel="false"
                 :is-full-page="true" />

        <div>
            <v-tour name="myTour" :steps="steps" :options="tourOptions" :callbacks="tourCallbacks"></v-tour>
        </div>

        <div v-if="!showIntroduction && !showContactSales && !showContactSalesComplete">
            <div v-if="showOrder" class="container" style="width:100%; height:170px;border-bottom: 1px solid lightgray; ">
                <div class="row">
                    <div class="col-xs-12">

                    </div>
                </div>
            </div>
            <div v-else class="container" style="width:100%; height:120px;border-bottom: 1px solid lightgray; ">
                <div class="row">
                    <div class="col-xs-12">

                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div v-show="showContactSales">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <h2 style="margin-top:30px;">Service Drive</h2>

                        <div class="setting-row" style="margin-top:20px;">
                            <div class="row">
                                <div class="col-sm-12">
                                    <p>
                                        Would you like more information and pricing on Service Drive?
                                    </p>
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <input v-model="contactCompanyName" type="text" class="form-control" placeholder="Company Name" name="txtContactCompanyName">
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <input v-model="contactContactName" type="text" class="form-control" placeholder="Contact Name" name="txtContactContactName">
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <input v-model="contactPhone" type="text" class="form-control" placeholder="Contact Name" name="txtContactPhone">
                                </div>
                                <div class="col-lg-6 col-md-6">
                                    <input v-model="contactEmail" type="text" class="form-control" placeholder="Email" name="txtContactEmailName">
                                </div>
                            </div>
                        </div>

                        <button @click="submitContactInformation" class="btn btn-primary" style="margin-top:30px;margin-bottom:40px;">Submit my Contact Info</button>
                    </div>
                </div>
            </div>
            <div v-show="showContactSalesComplete">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <p class="lead" style="margin-top:30px; margin-bottom:100px;">Thank you for reaching out to us.  A sales representative will contact you shortly.</p>
                    </div>
                </div>
            </div>
            <div v-show="showIntroduction && !showContactSales && !showContactSalesComplete">
                <div class="row">
                    <div class="col-md-8 col-md-offset-2">
                        <h2 style="margin-top:30px;">Service Drive</h2>
                        <p class="lead" style="margin-top:20px;">Service Drive allows your dealership to run a soft inquiry credit report (does not impact a consumer's score) without prior consent from the consumer using minimal consumer information.  The system will tell you key information about the consumer by accessing their Equifax credit report such as:</p>

                        <p class="lead" style="margin-top:20px;">
                            <ul style="list-style-type: disc; padding-left: 30px; font-size: 1.25rem; font-weight: 300;">
                                <li>Score</li>
                                <li>Existing auto tradelines including interest rate, term, monghtly payment, and equity</li>
                                <li>Available revolving credit</li>
                                <li>Other key information</li>
                            </ul>
                        </p>

                        <p class="lead" style="margin-top:20px;">While Service Drive, was designed to be used for consumers coming in for service appointments, it can be used with any consumers transacting with your dealership today.</p>

                        <button @click="startTour" class="btn btn-primary" style="margin-top:30px;margin-bottom:40px;">Start Tour</button>
                    </div>
                </div>
            </div>
            <div data-v-step="5" v-show="!showIntroduction && !showContactSales && !showContactSalesComplete">
                <div class="lr-inner">
                    <div class="lr-left">
                        <div data-v-step="1" class="white-r-border driver-admin">

                            <div class="card-close">
                                <a href="/dealership"><img src="../assets/close-card.svg" class="img-fluid" alt="close"></a>
                            </div>

                            <div data-intro="Enter the information of the applicant you want to order a credit check for." v-show="showOrder">

                                <div class="admin-title">
                                    <h3>Service Drive</h3>
                                </div>

                                <div class="setting-row">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <p>
                                                Submit the following applicant information to retrieve their credit report.
                                            </p>
                                        </div>
                                        <div id="orderScroll" class="col-lg-6 col-md-6">
                                            <input v-model="addFirstName" type="text" class="form-control" placeholder="First Name" name="txtAddFirstName">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addLastName" type="text" class="form-control" placeholder="Last Name" name="txtAddLastName">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addStreetAddress" type="text" class="form-control" placeholder="Street Address" name="txtAddStreetAddress">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addCity" type="text" class="form-control" placeholder="City" name="txtAddCity">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addState" type="text" class="form-control" placeholder="State" name="txtAddState">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addZipCode" v-mask="'#####'" type="text" class="form-control" placeholder="Zip Code" name="txtAddZipCode">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addPhoneNumber" v-mask="'###-###-####'" type="text" class="form-control" placeholder="Phone Number" name="txtAddPhoneNumber">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addEmail" type="email" class="form-control" placeholder="Email (Optional)" name="txtAddEmail">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addSSN" type="text" class="form-control" placeholder="SSN (Optional)" name="txtAddSSN">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addDateOfBirth" type="text" class="form-control" placeholder="Date of Birth (Optional)" name="txtAddDateOfBirth">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input v-model="addVinNumber" type="text" class="form-control" placeholder="VIN Number (Optional)" name="txtAddVinNumber">
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div data-v-step="2" class="col-lg-6 col-md-6">
                                            <input type="submit" value="Submit" name="btnGetCreditReport">
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input style="background-color: black" type="submit" value="Cancel" name="btnCancelGetCreditReport">
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-show="showprintoffer">

                                <div class="admin-title">
                                    <h3>Print Offer</h3>

                                    <div class="setting-row">
                                        <div class="col-sm-12">
                                            <p>
                                                The credit report has been retrieved.  The offer <strong>must be printed and presented to the consumer.</strong>
                                            </p>
                                        </div>
                                        <div data-v-step="3" class="col-lg-4 col-md-6" style="margin-top:30px;">
                                            <a href="#" target="_blank" class="btn btn-primary" id="btnPrintOffer">Print Offer</a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div v-show="showConfirmPrint">

                                <div class="admin-title">
                                    <h3>Print Offer</h3>

                                    <div class="setting-row">
                                        <div class="col-sm-12">
                                            <p>
                                                Please confirm that the Offer has been or will be presented to the consumer.
                                            </p>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input" id="chkOfferPresented" v-model="offerPresentedConfirmed">
                                                <span class="checkmark"></span>
                                                <label class="form-check-label" for="chkOfferPresented">I certify that the Offer has been or will be presented to the consumer</label>
                                            </div>
                                        </div>
                                        <div data-v-step="4" class="col-lg-4 col-md-6" style="margin-top:30px;">
                                            <input type="submit" value="Continue" name="btnShowCreditReport">
                                        </div>

                                    </div>
                                </div>

                            </div>
                            <div v-show="!showConfirmPrint && !showprintoffer && !showOrder">
                                <div class="white-r-border summary">
                                    <ul class="nav nav-tabs border-tabs" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <a class="nav-link active" id="fico-tab" data-toggle="tab" href="#fico" role="tab" aria-controls="fico" aria-selected="true">Service Drive</a>
                                        </li>
                                    </ul>
                                    <div class="tab-content border-tabs-content" id="myTabContent">
                                        <div class="tab-pane fade show active" id="fico" role="tabpanel" aria-labelledby="fico-tab">
                                            <div class="fico-summary">
                                                <h4>Auto summary ({{autoTradeLines.length}})</h4>
                                                <div class="avail-cred">
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Available Revolving Credit</p>
                                                            <h2>$8,925</h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p>Auto Inquiries Last 30 Days</p>
                                                            <h2>2 Inquiries</h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Open Auto Accounts</p>
                                                            <h2>2</h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p>Open Auto Accounts Balance</p>
                                                            <h2 class="treadopen-btn"></h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>Newest Auto Account Age</p>
                                                            <h2>5 months</h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p># of Auto Accounts with Derogatory Mark (24 mo)</p>
                                                            <h2>0</h2>
                                                        </div>
                                                    </div>
                                                    <div id="autoTradeLineScroll" class="listavail">
                                                        <div class="avl">
                                                            <p>Worst Rating</p>
                                                            <h2></h2>
                                                        </div>
                                                        <div class="avl">
                                                            <p></p>
                                                            <h2></h2>
                                                        </div>
                                                    </div>
                                                    <div class="listavail">
                                                        <div class="avl">
                                                            <p>(18) Open · (12) Closed</p>
                                                        </div>
                                                        <div class="avl">
                                                            <div class="opp-ic not">(0) Opportunities</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-v-step="7" id="interestRateScroll" v-for="(autoTradeLine, index) in autoTradeLines" :key="autoTradeLine.id" v-show="index < autoTradeLinesCountToShow" class="tredline-wrap" style="margin-bottom:20px;">
                                                    <div class="trad-left">
                                                        <h2>Auto Tradeline {{index+1}}</h2>
                                                        <a v-if="autoTradeLine.tradeLineStatus" href="#" class="treadopen-btn">Closed</a>
                                                        <a v-else href="#" class="treadopen-btn">Open</a>
                                                        <span>Opened: {{autoTradeLine.originalLoanDate}}</span>
                                                        <div class="tread-rev">
                                                            <div class="opp-ic not">Payment</div>
                                                            <h2 v-if="autoTradeLine.paymentAmount >= 0">${{autoTradeLine.paymentAmount}}</h2>
                                                            <h2 v-else class="treadopen-btn"></h2>
                                                        </div>
                                                        <div data-v-step="8" class="tread-rev">
                                                            <div class="opp-ic hot">Interest rate</div>
                                                            <h2 v-if="autoTradeLine.interestRate >= 0">{{autoTradeLine.interestRate}}</h2>
                                                            <h2 v-else class="treadopen-btn"></h2>
                                                        </div>
                                                    </div>
                                                    <div class="trad-right">
                                                        <div class="progress">
                                                            <div class="progress-bar" role="progressbar" :style="'width:' + calculateAutoTradelinePercent(autoTradeLine.loanAmount, autoTradeLine.loanAmountRemaining) + '%'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                        <div data-v-step="9" class="progress-data">
                                                            <div v-if="autoTradeLine.loanAmount >= 0" class="opp-ic not">Loan: ${{autoTradeLine.loanAmount}}</div>
                                                            <div v-else class="opp-ic treadopen-btn"></div>
                                                            <div v-if="autoTradeLine.loanAmountRemaining >= 0" class="opp-ic hot">Left: ${{autoTradeLine.loanAmountRemaining}}</div>
                                                            <div v-else class="opp-ic treadopen-btn"></div>
                                                        </div>
                                                        <div class="pro-stats">
                                                            <ul>
                                                                <li>
                                                                    <div class="opp-ic not">Terms</div>
                                                                    <p v-if="autoTradeLine.loanTermMonths >= 0">{{autoTradeLine.loanTermMonths}} mo</p>
                                                                    <p v-else class="treadopen-btn"></p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic hot">Remaining</div>
                                                                    <p>{{autoTradeLine.loanTermRemaining}} mo</p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic not">Late</div>
                                                                    <p>{{autoTradeLine.latePayments}}</p>
                                                                </li>
                                                                <li>
                                                                    <div class="opp-ic not">Joint</div>
                                                                    <p>No</p>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="tred-bottom">
                                                        <p>Auto Tradeline {{index+1}}</p>
                                                    </div>
                                                </div>
                                                <a class="more-tred">View 1 more</a>
                                            </div>
                                        </div>
                                        <div class="tab-pane fade " id="credit" role="tabpanel" aria-labelledby="credit-tab">
                                            <div class="fico-summary">
                                                <h4>Account balances</h4>
                                                <div class="account-bal">
                                                    <ul>
                                                        <li>
                                                            <strong>Total balances</strong>
                                                            <strong>$297,561</strong>
                                                        </li>
                                                        <li>
                                                            <span>Revolving credit</span>
                                                            <p>$8,925</p>
                                                        </li>
                                                        <li>
                                                            <span>Mortgages</span>
                                                            <p>$287,952</p>
                                                        </li>
                                                        <li>
                                                            <span>Installment Loans</span>
                                                            <p>$684</p>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="pastrecords">
                                                    <ul>
                                                        <li>
                                                            <h2>$0.00</h2>
                                                            <p>Past due</p>
                                                        </li>
                                                        <li>
                                                            <h2>0</h2>
                                                            <p># Past due</p>
                                                        </li>
                                                        <li>
                                                            <h2>0</h2>
                                                            <p>Public records</p>
                                                        </li>
                                                    </ul>
                                                    <ul>
                                                        <li>
                                                            <h2>$3,154</h2>
                                                            <p>Payments /mo</p>
                                                        </li>
                                                        <li>
                                                            <h2>65 months</h2>
                                                            <p>Oldest account</p>
                                                        </li>
                                                        <li>
                                                            <h2>2</h2>
                                                            <p>Total inquiries</p>
                                                        </li>
                                                    </ul>

                                                    <ul class="col2records">
                                                        <li>
                                                            <p>Credit utilization</p>
                                                            <h2>5%</h2>
                                                        </li>
                                                        <li>
                                                            <p>Hard inquiries</p>
                                                            <h2>1</h2>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div>
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" v-bind:style="'width: 90%'" aria-valuenow="0" v-bind:aria-valuemin="90" aria-valuemax="100"></div>
                                                    </div>
                                                    <div class="progress-data">
                                                        <p>Good standing <strong>10</strong></p>
                                                        <p>Potentially negative <strong>1</strong></p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <!-- right-content -->
                    <div class="lr-right" id="consumerScore">
                        <div v-show="!showConfirmPrint && !showprintoffer && !showOrder" class="white-r-border profile-sec summ">
                            <div class="card-close">
                                <a href="./"><img src="../assets/close-card.svg" class="img-fluid" alt="close"></a>
                            </div>
                            <div class="user-prof">
                                <h2>BASIL UUJZDJHK</h2>
                                <div class="buy-power">
                                    &nbsp;
                                </div>
                                <div class="info-title">
                                    <h2>Vantage Score <a href="#" alt="Click to toggle score comparison..." class="infolink" style="font-size: 20px"></a></h2>
                                </div>

                                <div data-v-step="6" class="tier">
                                    <div class="tire-denotr">
                                        <div class="tirenum">
                                            <h2>573</h2>
                                        </div>
                                        <div class="tire-rate">
                                            <div class="'quality-badge-fair'">Fair</div>
                                            <h3>Fair</h3>
                                        </div>
                                    </div>
                                    <div class="tire-badge">Tier 4</div>
                                </div>

                                <div class="tire-progress">
                                    <CreditScoreBarGraph :creditScore="573" :serviceDrive="true" />
                                </div>

                                <div id="tradeInScroll" class="info-title">
                                    <h2>Customer Information</h2>
                                </div>
                                <div class="contact-info">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h4>Cell</h4>
                                            <a href="#">555-987-6521</a>
                                        </div>
                                        <div class="col-sm-6">
                                            <h4>Email</h4>
                                            <a href="#">buujz@email.com</a>
                                        </div>
                                        <div class="col-sm-12">
                                            <h4>Address</h4>
                                            <p>9615 Black Tern Ln, Yonkers, NY 10710</p>
                                        </div>
                                    </div>
                                </div>


                                <div data-v-step="11" class="contact-info bg-back">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <h4>Current Trade-in</h4>
                                            <p>2017 Ford F-150</p>
                                            <p style="font-style:italic;font-weight:normal;">Acquired on 11/12/2021</p>
                                        </div>
                                        <div class="col-sm-6">
                                            <h4>Interested in </h4>
                                            <p>Unknown</p>
                                        </div>
                                    </div>
                                </div>


                                <div class="info-title">
                                    <h2>Pre-Qualification Certificate</h2>
                                </div>

                                <div class="get-certf">
                                    <div class="cert-img">

                                        <div class="cert-box">
                                            <div class="inner-white">
                                                <h2>Pre-Qualification</h2>
                                                <small>This certificate is presented to:</small>
                                                <h1>BASIL UUJZDJHK</h1>
                                                <p>You have been Pre-Qualified for financing VAID ONLY AT:</p>
                                                <h3>Santa Barbara Automotive</h3>
                                                <div class="cert-barcode"><img src="../assets/barcode-img.png" alt="img" class="img-fluid" height="30"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cert-actions">
                                        <a target="_blank" href="#">Print</a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <footer>
                            <CreditDriverFooter />
                        </footer>

                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import CreditScoreBarGraph from './CreditScoreBarGraph';
    import CreditDriverFooter from './CreditDriverFooter.vue';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mask } from 'vue-the-mask';
    import 'intro.js/minified/introjs.min.css';
    import VTour from './VTour.vue'
    import { vm } from '../main.js'

    export default {
        name: "ServiceDrive",
        props: {
        },
        computed: {
        },
        data() {
            return {
                addFirstName: "",
                addLastName: "",
                addEmail: "",
                addPhoneNumber: "",
                addSSN: "",
                addDateOfBirth: "",
                addStreetAddress: "",
                addCity: "",
                addState: "",
                addZipCode: "",
                addVinNumber: "",
                contactCompanyName: "",
                contactContactName: "",
                contactPhone: "",
                contactEmail: "",
                showContactSales: false,
                showContactSalesComplete: false,
                showIntroduction: true,
                showOrder: true,
                showprintoffer: false,
                showConfirmPrint: false,
                offerPresentedConfirmed: false,
                tourCallbacks: {
                    onFinish: this.tourFinish
                },
                tourOptions: {
                    useKeyboardNavigation: false,
                    highlight: true,
                    labels: {
                        buttonSkip: 'Skip tour',
                        buttonPrevious: 'Previous',
                        buttonNext: 'Next',
                        buttonStop: 'Finish'
                    }
                },
                steps: [
                    {
                        target: '[data-v-step="1"]',
                        /*header: {
                            title: 'Place a Service Drive Order',
                        },*/
                        content: `To access Service Drive, you only need some basic information.  This information is readily available on most service appointments.`,
                        params: {
                            placement: 'top' // Any valid Popper.js placement. See https://popper.js.org/popper-documentation.html#Popper.placements
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = true;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            setTimeout(function () {
                                window.scrollTo(0, 0);
                            }, 100);
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="2"]',
                        content: 'Click on the Submit button to place the order.',
                        params: {
                            placement: 'bottom'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = true;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            this.addFirstName = "Basil";
                            this.addLastName = "Uujzdjhk";
                            this.addStreetAddress = "9615 Black Tern Ln";
                            this.addCity = "Yonkers";
                            this.addState = "NY";
                            this.addZipCode = "10710";
                            this.addPhoneNumber = "555-987-6521";
                            this.addEmail = "buujz@email.com";
                            this.addSSN = "999-12-3456";
                            this.addVinNumber = "1HGBH41JXMN109186";

                            process.nextTick(() => {
                                var consumerScore = document.getElementById("orderScroll");
                                consumerScore.scrollIntoView();
                            });

                            resolve(true);
                        })
                    },
                    /*{
                        target: '[data-v-step="3"]',
                        content: 'Print the offer of credit letter...',
                        params: {
                            placement: 'right'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = true;
                            this.showConfirmPrint = false;
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="4"]',
                        content: 'Acknowledge that the offer of credit will be provided to the consumer, then click the Continue button.',
                        params: {
                            placement: 'bottom'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = true;
                            resolve(true);
                        })
                    },*/
                    {
                        target: '[data-v-step="5"]',
                        content: 'Results are displayed for the consumer',
                        params: {
                            placement: 'top',
                            enableScrolling: false
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                window.scrollTo(0, 0);
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="6"]',
                        content: 'The consumer\'s score',
                        params: {
                            placement: 'top',
                            enableScrolling: false
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("consumerScore");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="7"]',
                        content: 'See key auto tradeline data on ALL vehicles owned by the consumer, not just the vehicle coming in for service.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("autoTradeLineScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="8"]',
                        content: 'Opportunity alerts quickly alert you to potential sales indicators, such as a high interest rate.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("interestRateScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="9"]',
                        content: 'Or a low remaining balance.',
                        params: {
                            placement: 'bottom'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("interestRateScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    },
                    {
                        target: '[data-v-step="11"]',
                        content: 'Get potential trade-in information before the consumer arrives for their service appointment.',
                        params: {
                            placement: 'top'
                        },
                        // eslint-disable-next-line
                        before: type => new Promise((resolve) => {
                            this.showOrder = false;
                            this.showprintoffer = false;
                            this.showConfirmPrint = false;
                            process.nextTick(() => {
                                var consumerScore = document.getElementById("tradeInScroll");
                                consumerScore.scrollIntoView();
                            });
                            resolve(true);
                        })
                    }
                ],
                autoTradeLinesCountToShow: 1,
                autoTradeLines: [
                     {
                         id: 1,
                         leaseOrLoan: true,
                         tradeLineStatus: false,
                         cosignor: 8,
                         originalLoanDate: "Sep 12, 2016",
                         loanAmount: 35000,
                         loanAmountRemaining: 770,
                         latePayments: 0,
                         loanTermMonths: 72,
                         paymentAmount: 644.15,
                         estimatedPayOffDate: "Sep 12, 2022",
                         loanTermRemaining: 3,
                         interestRate: 8.50
                     },
                     {
                         id: 2,
                         leaseOrLoan: true,
                         tradeLineStatus: false,
                         cosignor: 4,
                         originalLoanDate: "Jan 3, 2018",
                         loanAmount: 36000,
                         loanAmountRemaining: 4200,
                         latePayments: 0,
                         loanTermMonths: 72,
                         paymentAmount: 244.25,
                         estimatedPayOffDate: "Nov 12, 2021",
                         loanTermRemaining: 3,
                         interestRate: 6.75
                     }
                ],
            }
        },
        methods: {
            startTour() {
                this.showIntroduction = false;
                vm.$tours['myTour'].start();
            },
            tourFinish() {
                this.showContactSales = true;
            },
            submitContactInformation() {
                this.showContactSales = false;
                this.showContactSalesComplete = true;
            },
            calculateAutoTradelinePercent(loanAmount, loanAmountRemaining) {
                return ((loanAmount - loanAmountRemaining) / loanAmount) * 100;
            }
        },
        mounted() {
            
        },
        directives: { mask },
        components: {
            CreditScoreBarGraph,
            CreditDriverFooter,
            VTour,
            Loading
        }
    }
</script>

<style type="text/css" scoped>
    @import '../css/style.css';
    @import '../css/style2.css';
    @import '../css/responsive.css';

    input[type="submit"]:disabled {
        background: #888;
        cursor: not-allowed;
    }


    input[type=checkbox] {
        /* Double-sized Checkboxes */
        -ms-transform: scale(1.5); /* IE */
        -moz-transform: scale(1.5); /* FF */
        -webkit-transform: scale(1.5); /* Safari and Chrome */
        -o-transform: scale(1.5); /* Opera */
        padding: 10px;
    }
</style>